/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Column_PlatformInputs */

const en_landing_footer_column_platform = /** @type {(inputs: Landing_Footer_Column_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Landing_Footer_Column_PlatformInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_column_platform = /** @type {((inputs?: Landing_Footer_Column_PlatformInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Column_PlatformInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_column_platform(inputs)
});